import { render, staticRenderFns } from "./SuccessInternalRegister.vue?vue&type=template&id=071f51a4"
import script from "./SuccessInternalRegister.vue?vue&type=script&lang=js"
export * from "./SuccessInternalRegister.vue?vue&type=script&lang=js"
import style0 from "./SuccessInternalRegister.vue?vue&type=style&index=0&id=071f51a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports